import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    /* Авторизация */
    user: null,
    isAuth: false,

    /* После авторизации */
    employees: [],
    departments: [],
    attendances: [],
  },
  mutations: {
    /* Мутации связанные с авторизацией */
    login (state, payload) {
      state.isAuth = true;
      state.user = payload
    },
    auth_success(state, payload){
      state.status = 'success'
      state.token = payload.token
      state.user = payload
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      state.isAuth = false;
      state.user = null
    },

    /* Мутации связанные с данными(Наклад, продукты, поставщики и тд) */
    setEmployees(state, payload) {
      state.employees = payload
    },
    setDepartments(state, payload) {
      state.departments = payload
    },
    setAttendances(state, payload) {
      state.attendances = payload
    },
  },
  actions: {
    /* Авторизация */
    login(context, payload){
      context.commit('login', payload)
    },
    logout(context) {
      context.commit('logout')
    },

    /* Данные */
    setEmployees(context, payload) {
      context.commit('setEmployees', payload)
    },
    setDepartments(context, payload) {
      context.commit('setDepartments', payload)
    },
    setAttendances(context, payload) {
      context.commit('setAttendances', payload)
    },
  },
  modules: {
  },
  getters: {
    /* Авторизация, аккаунт */
    userGroup: state => { return state.user.groups },


    /* Поставщики */
    employee: state => guid => { return state.employees.find(item => item.guid === guid) },
    employees: state => { return state.employees },
    // supplierProducts: (state, getters) => guid => { return getters.supplier(guid).products },

    /* Склады */
    departments: state => { return state.departments },

    /* Продукты */
    attendances: state => { return state.attendances },

    isAuth: state => { return state.isAuth },
    user: state => {return state.user},
    isManager: state => { return state.user?.category === 'manager' },
  }
})
